import { styled } from "@mui/material";
import type { ReactNode, Ref } from "react";

interface TableContainerProps {
  restrictedHeight: string;
  children?: ReactNode;
  ref?: Ref<HTMLDivElement>;
}

export const TableContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "restrictedHeight",
})<TableContainerProps>`
  position: relative;
  min-height: 300px;
  height: calc(100vh - ${(props) => props.restrictedHeight});
`;
